// extracted by mini-css-extract-plugin
export default {"resultSlider__photoItem":"vqW5Q_MD0Pw4PItKOOIg","resultSlider__photo":"eLStBFRVsoxhnnJwvAI_","resultSlider__slider":"fqR0XfAmWoqP_UoJxdF5"};